export const FOUNDERS_PHOTO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_academy-fede/artifacts/050df4e844f63f27_Screenshot%202026-10-06%20alle%2016.26.47.png";

export const VISION_PHOTO =
  "https://images.unsplash.com/photo-1572196588907-1835ea6dc5fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const DESERT_PHOTO =
  "https://images.unsplash.com/photo-1506147854445-5a3f534191f8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const MOUNTAIN_PHOTO =
  "https://images.unsplash.com/photo-1582564349321-fa699078269b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const DAWN_PHOTO =
  "https://images.unsplash.com/photo-1457264635001-828d0cbd483e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
